import React from 'react'

import { Page } from 'app/templates'

import { styled, theme } from 'ui/styles'
import { Text } from 'ui/components'
import { breakpoints, useDimensions } from 'shared/dimensions'
import { OUTSTAFF_MAIN_STEPS, OUTSTAFF_TEAM, OUTSTAFF_TEAM_ADAPTIVE } from 'app/data/teams'
import { MainSteps } from 'app/features/modals/molecules/main-steps'
import { Team as TeamList } from 'app/features/modals/molecules/team'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 0 64px 56px;
  z-index: 100;
  backdrop-filter: blur(12px);
  background: rgba(42, 61, 87, 0.95);

  @media (max-width: ${breakpoints.tablet}px) {
    padding: 0 32px 56px;
  }
`

const Content = styled.div`
  max-width: 850px;
`

const HeaderWrapper = styled.div`
  padding-top: 56px;

  display: flex;
  flex-direction: column;
  & > div:first-child {
    margin-bottom: 12px;
  }

  :not(:first-of-type) {
    padding-top: 64px;
  }
`

const StyledText = styled(Text)`
  margin-top: 32px;
  margin-bottom: 24px;
`

const MainStepsColumns = styled.div`
  display: flex;

  @media (max-width: ${breakpoints.tablet - 1}px) {
    flex-direction: column;
  }
`

export const Team: React.FC = () => {
  const { isDesktop } = useDimensions();

  const outstaffMainStepsColumnLeft = OUTSTAFF_MAIN_STEPS.slice(0, 3)
  const outstaffMainStepsColumnRight = OUTSTAFF_MAIN_STEPS.slice(3)
  
  return (
    <Page>
      <Wrapper>
        <Content>
          <HeaderWrapper>
            <Text variant="h3" color={theme.palette.white}>
              Выделенные проектные команды
            </Text>
            <Text bold variant="t3" color={theme.palette.white}>
              Рекомендуемая команда для разработки отдельных функций и выделенных стримов.
            </Text>
          </HeaderWrapper>
          <StyledText bold variant="t1" color={theme.palette.white}>
            Основные этапы:
          </StyledText>
          <MainStepsColumns>
            <MainSteps steps={outstaffMainStepsColumnLeft} />
            <MainSteps steps={outstaffMainStepsColumnRight} />
          </MainStepsColumns>
          <StyledText bold variant="t1" color={theme.palette.white}>
            Команда
          </StyledText>
          {isDesktop ? <TeamList team={OUTSTAFF_TEAM} /> : <TeamList team={OUTSTAFF_TEAM_ADAPTIVE} />}
        </Content>
      </Wrapper>
    </Page>
  )
}
